import { createBrowserHistory } from "history";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Input } from "reactstrap";
import MasonryDrawings from "../components/masonry-drawings";
import MultipleSpinners from "../components/multiple-spinners";
import SocialClub from "../components/social-club";
import { fetchAllCategories, fetchAllDrawings } from "../firebase";
import { fetchAllUsers, fetchPostsFirstBatch, fetchPostsNextBatch } from "../store";
import "../styles/drawing-list.scss";
import logo from '../styles/heyart-logo-one-line.svg';

function HomeScreen() {
  const dispatch = useDispatch()
  const location = useLocation()
  const history = createBrowserHistory()
  const [loading, setLoading] = useState(true)
  const [drawings, setDrawings] = useState([])
  const [categories, setCategories] = useState([])
  const [selectedCatId, setSelectedCatId] = useState('all')

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const categoryId = params.get('category')

    if (categoryId) {
      setSelectedCatId(categoryId)
    } else {
      setSelectedCatId('all')
    }
  }, [location])

  useEffect(() => {
    Promise.all([fetchAllDrawings(), fetchAllCategories()])
      .then(([drawings, categories]) => {
        setDrawings(drawings)
        setCategories(categories)
        setLoading(false)
      })

    dispatch(fetchPostsFirstBatch())
    dispatch(fetchAllUsers())
  }, [])

  function catNamePretty(name) {
    return name.charAt(0).toUpperCase() + name.replace(/-/g, ' ').slice(1);
  }

  function handleSelectCat(evt) {
    setSelectedCatId(evt.target.value)
    history.push("/?category=" + evt.target.value)
  }

  function drawingsInCatCount(catId) {
    return drawings.filter(({ categories }) => (catId === "all" || categories.includes(catId))).length
  }

  return (
    <div id="home">
      <SocialClub />

      <div id="main">
        <div id="topbar">
          <h3 id="title"><img src={logo} /></h3>
          <Input name="select" value={selectedCatId} type="select" size="sm" onChange={handleSelectCat}>
            <option value="all">All ({drawings.length})</option>

            <option disabled>──────────</option>

            {categories.map(({ name, id }) => (
              <option key={id} value={id}>{catNamePretty(name)} ({drawingsInCatCount(id)})</option>
            ))}
          </Input>
        </div>
        <div id="content" className={loading ? 'loading' : ''}>
          {loading && <MultipleSpinners />}
          {!loading && <MasonryDrawings drawings={drawings} categories={categories} selectedCatId={selectedCatId} />}
        </div>
      </div>
    </div >
  );
}

export default HomeScreen;
